export const environment = {
  appVersion: require('../../package.json').version + '-dev',
  production: false,
  baseUrl: 'https://loyaltyapi.maxbet.dev/',
  notificationCenterBaseUrl: 'https://loyalty-api.maxbet.dev/',

  loyaltyHubUrl: 'https://loyalty-api.maxbet.dev/loyaltyNotificationHub',
  cateringPurchaseHubUrl: 'https://purchase-api.maxbet.dev/purchaseNotificationHub',
  spendingHubUrl: 'https://spending-api.maxbet.dev/spendingNotificationHub',
  bettingPurchaseHubUrl: 'https://betting-purchase-api.maxbet.dev/bettingPurchaseNotificationHub',
  bettingSpendingHubUrl: 'https://betting-spending-api.maxbet.dev/bettingSpendingNotificationHub',
  notificationHubUrl:
    'https://loyalty-api.maxbet.dev/api/NotificationCenter/notificationCenterNotificationHub',

  siteKey: '0x4AAAAAACqKbgz2WkeQDmKt',

  localJackpot: { url: 'https://demo-jackpot.maxbet.dev/mobile', isActive: false },
  globalJackpotURL: { url: 'https://demo-jackpot.maxbet.dev/mobile', isActive: false }
};
